import { useSelector } from 'react-redux';

import { PermissionsEnums } from 'src/shared/enums';
import { validateListContains } from 'src/shared/utils';
import { RootState } from 'src/store/types';

export const usePermissions = (permissions: PermissionsEnums | PermissionsEnums[], strict?: boolean): boolean => {
  const { info } = useSelector((state: RootState) => state.user);
  return validateListContains(permissions, info?.permissions, 'permName', 'permDisabled', strict);
};
